import { render, staticRenderFns } from "./NatureAuthing.vue?vue&type=template&id=e7b4daa0&scoped=true&"
import script from "./NatureAuthing.vue?vue&type=script&lang=js&"
export * from "./NatureAuthing.vue?vue&type=script&lang=js&"
import style0 from "./NatureAuthing.vue?vue&type=style&index=0&id=e7b4daa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b4daa0",
  null
  
)

export default component.exports